import {
  RhButton,
  RhFormGroup,
  RhFormGroupItem,
  RhInput,
} from "@rhythm-ui/react";
import React, { useState } from "react";

type GenericType<T> = {
  values: T;
  valueKey: keyof T;
  setReactState: React.Dispatch<React.SetStateAction<T>>;
  options: { value: string; label: string }[];
  classname?: string;
  limitOptionsOnRenderTo?: number;
  __onChange?: () => void;
};

//TODO: Refactor this. It is not clear how to use this component
const CheckboxInput = <T extends object>({
  values,
  setReactState,
  valueKey,
  options,
  classname,
  limitOptionsOnRenderTo,
  __onChange,
}: GenericType<T>) => {
  const selectedValue = (values[valueKey] || []) as string[];

  const onChangeHandler = (newValue: string) => {
    if (selectedValue.includes(newValue)) {
      const newSelectedValue = selectedValue.filter(
        (value: string) => value !== newValue,
      );
      setReactState((state: T) => ({
        ...state,
        [valueKey]: newSelectedValue,
      }));
      __onChange ? __onChange() : null;
    } else {
      setReactState((state: T) => ({
        ...state,
        [valueKey]: [...selectedValue, newValue],
      }));
      __onChange ? __onChange() : null;
    }
  };

  const [displayCheckboxCount, setDisplayCheckboxCount] = useState(
    limitOptionsOnRenderTo,
  );

  // if limitOptionsOnRenderTo is more than the options length, then don't show "show more" button
  if (limitOptionsOnRenderTo && limitOptionsOnRenderTo >= options.length) {
    limitOptionsOnRenderTo = undefined;
  }

  const onShowMoreHandler = () => {
    setDisplayCheckboxCount((state) => {
      if (state === options.length) return limitOptionsOnRenderTo;
      else return options.length;
    });
  };

  return (
    <>
      <RhFormGroup>
        <div className={`flex flex-col ${classname ?? ""}`}>
          <>
            {limitOptionsOnRenderTo ? (
              <>
                {options
                  .slice(0, displayCheckboxCount)
                  .map((option: { value: string; label: string }) => (
                    <CheckboxItem
                      key={option.value}
                      option={option}
                      onChangeHandler={onChangeHandler}
                      selectedValue={selectedValue}
                    />
                  ))}
                <RhButton
                  layout="link"
                  onClick={onShowMoreHandler}
                  className="w-fit p-0"
                >
                  {displayCheckboxCount !== options.length
                    ? `+${options.length - limitOptionsOnRenderTo} more`
                    : `Show less`}
                </RhButton>
              </>
            ) : (
              <>
                {options.map((option: { value: string; label: string }) => (
                  <CheckboxItem
                    key={option.value}
                    option={option}
                    onChangeHandler={onChangeHandler}
                    selectedValue={selectedValue}
                  />
                ))}
              </>
            )}
          </>
        </div>
      </RhFormGroup>
    </>
  );
};

export default CheckboxInput;

const CheckboxItem = ({
  option,
  onChangeHandler,
  selectedValue,
}: {
  option: {
    value: string;
    label: string;
  };
  onChangeHandler: (newValue: string) => void;
  selectedValue: string[];
}) => {
  return (
    <>
      <RhFormGroupItem
        className="text-gray-700"
        key={option.value}
        control={
          <RhInput
            onChange={(e) => onChangeHandler(e.target.value)}
            type="checkbox"
            value={option.value}
            checked={selectedValue.includes(option.value)}
            className="m-tnano !rounded-sm"
          />
        }
        label={option.label}
      />
    </>
  );
};
